const BMF_CONNECT_HOST_MATCH = /^https:\/\/bmf-connect\.[^/]+/;

export function bmfConnectImageUrl(url) {
   if (!url) return url;
   return url.replace(BMF_CONNECT_HOST_MATCH, '');
}

export function buildMountingStageUrl(carId, rimId, colorId, offset = 0, language = 'de') {
   const bmfCarId = (carId && carId.match(/^([a-zA-Z0-9]+)/) || [])[1] || carId;
   const color = colorId || 'default';
   return `/api/bmf/image/${language}/Car2d/mountingStage/${bmfCarId}/${rimId}/${offset}/${color}.png`;
}
